import React from 'react';
import styles from './LineLoader.module.css';
interface Props {
  showLoadingAnimation: boolean;
}
const LineLoader = ({
  showLoadingAnimation
}: Props) => {
  return <div className={styles.lineLoaderContainer} data-sentry-component="LineLoader" data-sentry-source-file="LineLoader.tsx">
      {showLoadingAnimation && <div className={styles.lineLoader}>
          <div className={styles.lineLoaderElement} />
        </div>}
    </div>;
};
export default LineLoader;